import {useTranslation} from "@i18n/client";
import React, {useState} from "react";

import {SpecialtyId} from "../../../constants/specialtyIds";
import {getSchedulingRedirectUrl} from "../../../utils/getRedirectUrl";
import {trackToPatient} from "src/utils/googleAnalytics";
import styles from "./Reasons.module.scss";

const Reasons = ({reasons, currentSpecialtyId}: any) => {
  const i18n = useTranslation();
  const [key, setKey] = useState();
  const [focus, setFocus] = useState(false);

  let filteredReasons = reasons
    // @ts-expect-error TS7006: Parameter 'r' implicitly has an 'any' type.
    .filter(r => r.specialtyIds.includes(currentSpecialtyId))
    // @ts-expect-error TS7006: Parameter 'r' implicitly has an 'any' type.
    .filter(r => (key ? r.name.toUpperCase().includes(key) : true));

  // get popular only for virtual urgent care cos there is a lot
  if (currentSpecialtyId === SpecialtyId.VIRTUAL_URGENT_CARE) {
    // @ts-expect-error TS7006: Parameter 'r' implicitly has an 'any' type.
    filteredReasons = filteredReasons.filter(r =>
      // @ts-expect-error TS7006: Parameter 'reasonSpecialty' implicitly has an 'any' type.
      r.practiceApptReasonSpecialties.some(reasonSpecialty => reasonSpecialty.sortIndex),
    );
  }

  return (
    <section aria-label={i18n.t("Common Reasons")} className={`${styles.wrap} contrast-tbt`}>
      <div className={`${styles.c2} contrast-tbr`}>
        <div className={styles.c2C1}>
          <h2 className={styles.c2R1}>{i18n.t("How can we help you today?")}</h2>
          <div className={`${styles.c2R2} ${key || focus ? styles.on : ""}`}>
            <input
              className={styles.c2R2C2}
              placeholder={i18n.t("Start typing a symptom...")}
              aria-label={i18n.t("Filter symptoms")}
              type="text"
              // value={key}
              onChange={(e: any) => setKey(e.target.value.toUpperCase())}
              onFocus={() => setFocus(true)}
              onBlur={() => setFocus(false)}
            />
            <span className={`cIcon-search2 ${styles.c2R2C1}`} aria-hidden />
            <div className="visually-hidden" aria-live="polite">
              {i18n.t("{{count}} matches found", {
                count: filteredReasons.length,
              })}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.c1}>
        <div className={styles.c1R1}>
          {!filteredReasons.length && (
            <div className={styles.crReason} style={{display: "block"}}>
              <span className="db darkerBlue-f">{i18n.t("No result found")}</span>
              <a
                href={getSchedulingRedirectUrl({
                  virtual: true,
                  specialtyId: currentSpecialtyId,
                })}
                className={styles.crReason}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackToPatient()}
              >
                {i18n.t("See all symptoms")}{" "}
                <span className={`${styles.rArr} cIcon-bigRightArrow`} aria-hidden />
              </a>
            </div>
          )}
          <ul>
            {/* @ts-expect-error TS7006: Parameter 'r' implicitly has an 'any' type. */}
            {filteredReasons.map(r => (
              <li key={r.id}>
                <a
                  href={getSchedulingRedirectUrl({
                    apptReasonId: r.id,
                    virtual: true,
                    specialtyId: currentSpecialtyId,
                  })}
                  className={`${styles.crReason} fbce`}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => trackToPatient()}
                >
                  {i18n.t(r.name)}
                  <span className={`${styles.book} contrast-tb`}>{i18n.t("Book Appointment")}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Reasons;
